export default __webpack_public_path__ + "static/media/link_iamsmart.934a68da.png";